import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import React from "react";
import Grid from "@material-ui/core/Grid";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import { useAuth } from "reactfire";
import Avatar from "@material-ui/core/Avatar";

function UserDataCard({ user, userData }) {
  const auth = useAuth();

  const logout = async () => {
    await auth.signOut().catch((error) => {
      console.error(error);
      alert(error.message || error);
    });
  };

  const { name, phoneNumber, streetAddress, postalCode } = userData;

  const userComplete =
    name && phoneNumber && streetAddress && postalCode != null;

  return (
    <Card>
      <CardContent>
        <Grid container wrap="nowrap" justify="space-between">
          {userComplete ? (
            <Grid item>
              <Typography>
                {userData.name}
                <br />
                {userData.phoneNumber}
              </Typography>
              <Typography color="textSecondary" variant="body2">
                {userData.streetAddress}, {userData.postalCode}
              </Typography>
            </Grid>
          ) : (
            <Grid item>
              <Typography color="textSecondary">
                Du hast noch keine Daten in deinem Profil hinterlegt.
              </Typography>
            </Grid>
          )}
          {user.photoURL != null ? (
            <Grid item>
              <img
                src={user.photoURL}
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 40,
                  objectFill: "cover",
                  marginLeft: 16,
                }}
                alt={`Bild von ${userData.name}`}
              />
            </Grid>
          ) : (
            <Grid item>
              <Avatar style={{ marginLeft: 16 }} />
            </Grid>
          )}
        </Grid>
      </CardContent>
      <CardActions>
        <Button variant="text" onClick={logout} size="small" color="secondary">
          Abmelden
        </Button>
      </CardActions>
    </Card>
  );
}

export default UserDataCard;
